const ACCOUNT_ID_TYPE_NAME = 'AccountId';

export { ACCOUNT_ID_TYPE_NAME };
